module.exports = __webpack_public_path__ + "static/media/bone.8c5aa2f7.svg";